<template>
  <div class="main">
    <div class="title-bar">
      <div class="row">
        <div class="col-12 col-md-6 mb-4 text-center text-md-left">
          <h1 class="mb-0">Online Enrollment Complete</h1>
        </div>
        <div class="col-12 col-md-6 mb-3 text-center text-md-right">
          <a
            class="btn btn-primary w-75 mb-2 w-sm-auto mb-sm-0"
            target="_blank"
            :href="route('enroll.online.print', { queue: queue.id })"
            >Print Confirmation</a
          >
          <a class="btn btn-info w-75 w-sm-auto ml-sm-2" :href="returnUrl"
            >Back to Catalog</a
          >
        </div>
      </div>
    </div>
    <div class="content py-4 px-xl-2">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="panel p-4 mb-4">
              <h3 class="text-center text-primary font-weight-bold mb-2">
                Thank you! Your enrollment was successful!
              </h3>
              <p class="text-center mb-4">
                All enrolled users should have received an email confirming
                their enrollment.
              </p>
              <SuccessItem
                v-for="(item, i) in queue.items"
                :key="i"
                :item="item"
                :index="i"
              />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="sticky-top">
              <div class="checkout-summary panel p-4 mb-4">
                <h3 class="text-center text-primary font-weight-bold">
                  Purchase Summary
                </h3>
                <div class="row" style="font-size: 14px">
                  <div class="col-8">
                    Subtotal ({{ queue.items.length }} items)
                  </div>
                  <div class="col-4 text-right">{{ subtotal | cost }}</div>
                </div>
                <div
                  v-if="!!coupon"
                  class="row text-primary"
                  style="font-size: 14px"
                >
                  <div class="col-8">Coupon: {{ coupon.code }}</div>
                  <div class="col-4 text-right">- {{ discount | cost }}</div>
                </div>
                <hr />
                <div class="row">
                  <div class="col font-weight-bold">
                    <h3>Total</h3>
                  </div>
                  <div class="col font-weight-bold text-right">
                    <h3>* {{ total | cost }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SuccessItem from "../partials/SuccessItem";
export default {
  components: {
    SuccessItem,
  },
  props: {
    queue: { type: Object, required: true },
    order: { type: Object, required: true },
    referer: { type: String, default: null },
  },
  data() {
    return {
      subtotal: null,
      discount: null,
      total: null,
      coupon: null,
    };
  },
  computed: {
    returnUrl() {
      return this.referer || this.route("catalog.online");
    },
  },
  created() {
    this.subtotal = this.order.subtotal;
    this.discount = this.order.discount;
    this.total = this.order.total;
    this.coupon = !!this.order.coupon ? this.order.coupon : null;
  },
};
</script>